/**
 * 碰撞回店统计
 */
import { BACKSTORESTATISTICS } from '../types';

export default {
    name: `${BACKSTORESTATISTICS}`,
    path: '/backStoreStatistics',
    component: () => import(/* webpackChunkName: 'backStoreStatistics' */ '@/views/backStoreStatistics/'),
    redirect: { name: `${BACKSTORESTATISTICS}Index` },
    meta: {
        title: '碰撞回店统计',
        savedPosition: { x: 0, y: 0 },
        noCache: true,
    },
    children: [
        {
            name: `${BACKSTORESTATISTICS}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'backStoreStatistics' */ '@/views/backStoreStatistics/home/Home.vue'),
        },

        // 二级页面示例, 没有二级页面就直接删掉
        // {
        //     name: `${BACKSTORESTATISTICS}Detail`,
        //     path: 'detail',
        //     component: () => import(/* webpackChunkName: 'backStoreStatistics' */ '@/views/backStoreStatistics/detail/Detail.vue'),
        // },
    ],
};
